import React, { useState, useEffect } from 'react';
import { AppContext } from '../../App';
import styles from './knockouttree2.module.scss';

import { ButtonBar } from '../ButtonBar';
import { Tree } from './tree';
import { RankingTable2 } from '../RankingTable2';
import { dataFetcher } from '../../Utils/dataFetcher';
import { GAtrack } from '../../Utils/tracking';
import { Spoiler } from '../Spoiler';
let timeout;

/**
 * finds a specific heat in all rounds
 *
 * @param {[*]} rounds
 * @param {*} heat
 */
const findHeat = (rounds, heat) => {
  if (!rounds || !heat) {
    return;
  }

  for (let roundI = 0; roundI < rounds.length; roundI++) {
    if (rounds[roundI] && rounds[roundI].heats) {
      for (let heatsI = 0; heatsI < rounds[roundI].heats.length; heatsI++) {
        if (rounds[roundI].heats[heatsI].id === heat.id) {
          return rounds[roundI].heats[heatsI];
        }
      }
    }
  }
};

/**
 * Builds a knockout tree view
 */
const KnockOutTree2 = ({ config }) => {
  const context = React.useContext(AppContext);
  const uriConfig = context.config.uriConfig;

  const [buttons, setButtons] = useState(
    config.buttons.map((text, index) => {
      return { text: text, active: index === 0 };
    })
  );
  const [heat, setHeat] = useState();
  const [dataSet, setDataSet] = useState();
  const [activeName, setActiveName] = useState('');
  const { spoilerKO2, setSpoilerKO2 } = context;
  const [loading, setLoading] = useState(true);
  // const activeName = buttons.find(({ active }) => !!active).text;

  /**
   * set currently active heat when dataSet is changed
   */
  useEffect(() => {
    if (heat && heat.id && activeName && dataSet[activeName.toLowerCase()]) {
      const newHeat = findHeat(dataSet[activeName.toLowerCase()].rounds, heat);
      setHeat(newHeat);
    }
    if (dataSet && dataSet[activeName.toLowerCase()]) {
      setLoading(false);
    }
  }, [dataSet, activeName, heat]);

  const setActiveEvent = () => {
    if (config.hasOwnProperty('uriActiveEvent')) {
      dataFetcher(config.uriActiveEvent).then((data) => {
        if (
          !data.error &&
          data.hasOwnProperty('event') &&
          config.apiUris.length > 0 &&
          config.apiUris[0].eventId === data.event.id
        ) {
          setActiveName(config.buttons[0]);
          setButtons(() =>
            config.buttons.map((text, index) => {
              return { text: text, active: index === 0 };
            })
          );
        } else if (
          !data.error &&
          data.hasOwnProperty('event') &&
          config.apiUris.length > 0 &&
          config.apiUris[1].eventId === data.event.id
        ) {
          setActiveName(config.buttons[1]);
          setButtons(() =>
            config.buttons.map((text, index) => {
              return { text: text, active: index === 1 };
            })
          );
        } else {
          setActiveName(config.buttons[0]);
          setButtons(() =>
            config.buttons.map((text, index) => {
              return { text: text, active: index === 0 };
            })
          );
        }
      });
    } else {
      setActiveName(config.buttons[0]);
      setButtons(() =>
        config.buttons.map((text, index) => {
          return { text: text, active: index === 0 };
        })
      );
    }
  };

  const setData = async () => {
    let isActivePoll = false;

    for (let apiNr = 0; apiNr < config.apiUris.length; apiNr++) {
      const { forButton, uri, crosslinkDetails } = config.apiUris[apiNr];
      let data = await dataFetcher(uri, uriConfig);
      data = { ...data, ...{ crosslinkDetails: crosslinkDetails } };
      if (data) {
        setDataSet((dataSet) => {
          return { ...dataSet, [forButton.toLowerCase()]: data };
        });
      }
      if (data.status === 'active') {
        isActivePoll = true;
      }
    }

    if (isActivePoll) {
      timeout = setTimeout(
        setData,
        config.pollRateSeconds ? config.pollRateSeconds * 1000 : 15000
      );
    }
  };

  /**
   * Manage API calls, updates when config is updated
   */
  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout);
    }
    setActiveEvent();
    setData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  /**
   * cleanup when component will unmount
   */
  useEffect(() => {
    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      // eventCategory: 'video',
      // eventAction: 'sidebar',
      // eventLabel: 'loaded',
      video_sidebar: {
        value: 'Navigation',
        widgetType: `Knockout Tree - ${config.trackingTitle || config.navigationTitle}`
      }
      // }
    };

    GAtrack(dataLayerArgs);

    return () => {
      if (timeout) clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Sets data to the tree specified by button
   *
   * @param {number} index
   */
  const buttonAction = (index) => {
    let oldIndex = 0;
    for (let checkIndex = 0; checkIndex < buttons.length; checkIndex++) {
      if (buttons[checkIndex].active === true) {
        oldIndex = checkIndex;
        break;
      }
    }

    // if (oldIndex !== index) {
    //   setHeat(undefined);
    // }
    setActiveName(config.buttons[index]);
    const newButtons = buttons.map((button) => {
      return { ...button, active: false };
    });
    newButtons[index].active = true;

    setButtons(newButtons);

    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      // eventCategory: 'video',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `${newButtons[index].text}`,
        widget_type: `Knockout Tree - ${config.trackingTitle || config.navigationTitle}`
      }
      // eventAction: 'sidebar'
      // }
    };

    GAtrack(dataLayerArgs);
  };

  // if (spoilerKO2) return <Spoiler onClick={() => setSpoilerKO2(!spoilerKO2)} />;
  // console.log(heat);
  return (
    <>
      {!loading && dataSet && (
        <>
          {buttons.length > 1 ? (
            <ButtonBar buttons={buttons} onClick={buttonAction} />
          ) : (
            <br />
          )}
          <Tree
            data={
              dataSet[activeName.toLowerCase()]
                ? dataSet[activeName.toLowerCase()].rounds
                : []
            }
            setHeat={setHeat}
            activeHeat={heat}
            category={activeName}
            config={config}
            focus={
              dataSet[activeName.toLowerCase()]
                ? dataSet[activeName.toLowerCase()].focus_changes[
                    dataSet[activeName.toLowerCase()].focus_changes.length - 1
                  ]
                : undefined
            }
          />

          <div className="appRow full-width-generic">
            <div className={styles.separator}></div>
          </div>

          <RankingTable2
            heat={heat}
            data={
              dataSet[activeName.toLowerCase()]
                ? dataSet[activeName.toLowerCase()].rounds
                : []
            }
            config={{
              ...config,
              ...{ crosslinkDetails: dataSet[activeName.toLowerCase()].crosslinkDetails }
            }}
          />
        </>
      )}
    </>
  );
};

export { KnockOutTree2 };
